/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsProtected {
  /**
   * Follows a Javascript convention where the method name starts with `_`
   *
   * @public
   * @function f1.is.protected
   * @example
   *
   * ```ts
   * f1.is.protected('__doF1') => false
   * f1.is.protected('_doF1') => true
   * f1.is.protected('doF1') => false
   * ```
   */
  (methodName: string): boolean;
}

/**
 * @see IsProtected
 */
export default (methodName: string): boolean => {
  return methodName.startsWith('_');
};
